import React from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import Cards from '../../../components/ui/card'
import { Medical, Syringe } from '../../../assets/icons'
import { SEARCH_TYPES } from '../constants'
import colors from '../../../styles/colors'
import fonts from '../../../styles/fonts'
import { Title } from '../../../components/ui/text'
import { HideBackTextOnMobileHeader as BackHeader } from '../../../components/ui/header'
import { CardSection, Section } from '../../../styles/sections'

const DIAGNOSTIC_STUDIES_ROUTE = '/inicio/novedades'

const Container = styled.div`
	width: 100%;
`

const SearchTypeSelection = ({ onNext }) => {
	const history = useHistory()

	const cardsList = [
		{
			id: SEARCH_TYPES.MEDICAL_SPECIALTIES,
			title: 'Especialidades médicas',
			subtitle: 'Buscá por especialidad',
			Icon: Medical,
			routes: SEARCH_TYPES.MEDICAL_SPECIALTIES
		},
		{
			id: SEARCH_TYPES.DIAGNOSTIC_STUDIES,
			title: 'Estudios de diagnóstico',
			subtitle: 'Buscá por nombre de estudio',
			Icon: Syringe,
			routes: SEARCH_TYPES.DIAGNOSTIC_STUDIES
		}
	]

	const handleSelectType = type => {
		if (type === SEARCH_TYPES.DIAGNOSTIC_STUDIES) {
			history.push(DIAGNOSTIC_STUDIES_ROUTE)
			return
		}

		onNext()
	}

	return (
		<Container>
			<BackHeader
				hideBackOnMobile={false}
				title={
					<Title
						size={fonts.fontSizes.xxl}
						color={colors.text.titleText}
						margin="0 0 24px 0"
						fontWeight={fonts.fontWeight.semibold}
					>
						¿Qué estás buscando?
					</Title>
				}
			/>
			<Section>
				<CardSection>
					<Cards
						iconColor={colors.brand.green}
						list={cardsList}
						onClick={handleSelectType}
						mobileColumns={1}
						fullMobileCard={true}
						roundedIcon={true}
					/>
				</CardSection>
			</Section>
		</Container>
	)
}

export default SearchTypeSelection
